var getDisplayName = (function (component) {
  return component.displayName || component.name || (typeof component === 'string' ? component : 'Component');
});

export default getDisplayName;
